// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import { applyTheme as coreApplyTheme, generateThemeStylesheet as coreGenerateThemeStylesheet, } from '@cloudscape-design/theming-runtime';
import { preset } from '../internal/generated/theming';
const VISUAL_REFRESH_THEME_ID = 'visual-refresh';
export function applyTheme({ theme, baseThemeId, selector }) {
    return coreApplyTheme({
        override: theme,
        preset,
        selector,
        baseThemeId: baseThemeId !== null && baseThemeId !== void 0 ? baseThemeId : (selector ? VISUAL_REFRESH_THEME_ID : undefined),
    });
}
export function generateThemeStylesheet({ theme, baseThemeId, selector }) {
    return coreGenerateThemeStylesheet({
        override: theme,
        preset,
        baseThemeId: baseThemeId !== null && baseThemeId !== void 0 ? baseThemeId : (selector ? VISUAL_REFRESH_THEME_ID : undefined),
        selector,
    });
}
const themeStorageKey = Symbol.for('awsui-global-theme');
const themeChangeEvent = 'awsui-global-theme-change';
function getTopWindow() {
    try {
        if (window.top && window.top.document) {
            return window.top;
        }
    }
    catch {
        // Cross-origin access error — fall back to current window.
    }
    return window;
}
export function setGlobalTheme(theme) {
    if (typeof window === 'undefined') {
        return;
    }
    const topWindow = getTopWindow();
    topWindow[themeStorageKey] = theme;
    topWindow.dispatchEvent(new Event(themeChangeEvent));
}
function getGlobalTheme() {
    const topWindow = getTopWindow();
    return topWindow[themeStorageKey];
}
export function applyGlobalTheme() {
    if (typeof window === 'undefined') {
        return { reset: () => { } };
    }
    const topWindow = getTopWindow();
    let currentReset;
    function apply() {
        currentReset === null || currentReset === void 0 ? void 0 : currentReset();
        currentReset = undefined;
        const theme = getGlobalTheme();
        if (theme) {
            const result = applyTheme({ theme });
            currentReset = result.reset;
        }
    }
    // Apply the current global theme immediately.
    apply();
    // Listen for future global theme changes.
    const listener = () => {
        apply();
    };
    topWindow.addEventListener(themeChangeEvent, listener);
    return {
        reset: () => {
            currentReset === null || currentReset === void 0 ? void 0 : currentReset();
            currentReset = undefined;
            topWindow.removeEventListener(themeChangeEvent, listener);
        },
    };
}
//# sourceMappingURL=index.js.map